export const PART_TYPES = Object.freeze({
  FACE_SHAPE: 'faceShape',
  EYES: 'eyes',
  EYE_LINER: 'eyeLiner',
  EYE_SHADOW: 'eyeShadow',
  GLASSES: 'glasses',
  EYEBROWS: 'eyebrows',
  EARS: 'ears',
  NOSE: 'nose',
  MOUTH: 'mouth',
  FACIAL_HAIR: 'facialHair',
  FACIAL_LINES: 'facialLines',
  FACIAL_LINES_CHEEK: 'facialLinesCheek',
  FACIAL_LINES_CHIN: 'facialLinesChin',
  FACIAL_LINES_EYES: 'facialLinesEyes',
  FACIAL_LINES_FOREHEAD: 'facialLinesForehead',
  HAIR: 'hair',
  HAIR_BACK: 'hairBack',
  JEWELRY: 'jewelry',
  JEWELRY_EARRINGS: 'jewelryEarrings',
  JEWELRY_NECKLACES: 'jewelryNecklaces',
  HATS: 'hats',
  SHIRT: 'shirt',
})

export const TRANSFORMATION_TYPES = Object.freeze({
  VERTICAL_OFFSET: 'VERTICAL_OFFSET',
  SCALE: 'SCALE',
  ROTATION: 'ROTATION',
  SPACING: 'SPACING',
})

export const FACE_RENDER_TYPES = Object.freeze({
  FINISHED: 'FINISHED',
  CIRCLE_FRAMED: 'CIRCLE_FRAMED',
  SQUARE_FRAMED: 'SQUARE_FRAMED',
})

export const COLORS = Object.freeze({
  WHITE: '#fff',
  BLACK: '#000',
})

export const SHIRT_COLOR_TYPES = Object.freeze({
  MAIN: 'MAIN',
  SECOND: 'SECOND',
})
